function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

/* Reveal navigation on a small upward scroll, including at the page bottom. */
(() => {
  let cleanup;
  function mountScrollHeader() {
    if (cleanup) cleanup();
    const header = document.querySelector('.section-header');
    if (!header) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const native = header.querySelector('sticky-header');
    if (native?.onScrollHandler) window.removeEventListener('scroll', native.onScrollHandler);
    header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    header.classList.add('nido-scroll-header');
    const spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.hidden = true;
    header.before(spacer);
    let previousY = scrollPosition();
    let travel = 0;
    let direction = 0;
    let frame = 0;
    function scrollPosition() {
      const limit = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      return Math.max(0, Math.min(window.scrollY, limit));
    }
    function show() { header.classList.remove('nido-header-hidden'); }
    function updateHeight() {
      spacer.style.height = `${header.offsetHeight}px`;
      document.documentElement.style.setProperty('--nido-header-height', `${header.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    }
    function update() {
      frame = 0;
      const y = scrollPosition();
      const floating = y > header.offsetHeight;
      spacer.hidden = !floating;
      header.classList.toggle('nido-header-floating', floating);
      const delta = y - previousY;
      previousY = y;
      if (y <= header.offsetHeight || header.querySelector('details[open]') || header.contains(document.activeElement)) {
        show(); travel = 0; return;
      }
      if (Math.abs(delta) < 0.5) return;
      const nextDirection = Math.sign(delta);
      travel = nextDirection === direction ? travel + Math.abs(delta) : Math.abs(delta);
      direction = nextDirection;
      if (travel >= (direction < 0 ? 4 : 8)) {
        header.classList.toggle('nido-header-hidden', direction > 0);
        travel = 0;
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    window.addEventListener('scroll', schedule, { ...options, passive: true });
    header.addEventListener('focusin', show, options);
    header.addEventListener('toggle', show, { ...options, capture: true });
    const observer = new ResizeObserver(updateHeight);
    observer.observe(header);
    updateHeight();
    cleanup = () => {
      controller.abort(); observer.disconnect(); cancelAnimationFrame(frame);
      header.classList.remove('nido-scroll-header', 'nido-header-hidden', 'nido-header-floating');
      spacer.remove();
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountScrollHeader, { once: true });
  else mountScrollHeader();
  document.addEventListener('shopify:section:load', mountScrollHeader);
})();
